const getStringValue = (value) => {
  if (value == null) return "";
  if (typeof value === "number") return String(value);
  if (typeof value === "string") return value.trim();
  return "";
};

const uniqueValues = (values) => [...new Set(values.filter(Boolean))];

const scoreNumber = (value) => {
  const digits = value.replace(/\D/g, "");
  const digitCount = digits.length;
  const looksExternal = digitCount >= 8;
  const hasPlus = value.startsWith("+");

  if (digitCount === 0) return -1;

  // Prefer full external numbers over short internal extensions.
  return (looksExternal ? 100 : 0) + (hasPlus ? 5 : 0) + digitCount;
};

const pickBestNumber = (values) => {
  const candidates = uniqueValues(values.map(getStringValue));
  if (!candidates.length) return null;
  return candidates.sort((a, b) => scoreNumber(b) - scoreNumber(a))[0];
};

const CALL_FROM_KEYS = [
  "call_from",
  "from_number",
  "caller_number",
  "caller",
  "from",
  "source_number",
  "src",
  "src_number",
  "src_no",
  "fromNo",
  "fromNumber",
  "outbound_caller_id",
  "did_number",
];

const CALL_TO_KEYS = [
  "call_to",
  "to_number",
  "callee_number",
  "callee",
  "to",
  "destination_number",
  "dst",
  "dst_number",
  "dst_no",
  "toNo",
  "toNumber",
];

export const resolveCallFromNumber = (record = {}) =>
  pickBestNumber(CALL_FROM_KEYS.map((key) => record?.[key]));

export const resolveCallToNumber = (record = {}) =>
  pickBestNumber(CALL_TO_KEYS.map((key) => record?.[key]));
